/**
 * Redacción de campos sensibles antes de exportar (08-seguridad-privacidad.md:
 * "Exportación redacta campos configurados"). Aplica de forma recursiva y
 * determinista sobre cualquier estructura JSON serializable.
 */
const SENSITIVE_KEY_PATTERN = /(token|password|secret|api[-_]?key|authorization|cookie|credential)/i;

export function redactValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => redactValue(item));
  }
  if (value !== null && typeof value === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      result[key] = SENSITIVE_KEY_PATTERN.test(key) ? "[REDACTED]" : redactValue(val);
    }
    return result;
  }
  if (typeof value === "string" && SENSITIVE_KEY_PATTERN.test(value)) {
    return value;
  }
  return value;
}

export function redactHeaders(headers: Record<string, string>): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(headers)) {
    result[key] = SENSITIVE_KEY_PATTERN.test(key) ? "[REDACTED]" : value;
  }
  return result;
}
